import {
  CheckSquare,
  FileText,
  FolderKanban,
  Hash,
  LayoutDashboard,
  LayoutTemplate,
  Lightbulb,
  Pin,
  Puzzle,
  Search,
  Settings,
  Sparkles,
  Trash2,
  Upload,
  Waypoints,
  type LucideIcon,
} from 'lucide-react';

/** The app's modules, each with its icon and colour (see `.mod-*` in styles.css). */
export type Module =
  | 'dashboard'
  | 'tasks'
  | 'projects'
  | 'memos'
  | 'ai'
  | 'templates'
  | 'graph'
  | 'plugins'
  | 'neutral';

export const MODULE_ICON: Record<string, { module: Module; icon: LucideIcon }> = {
  dashboard: { module: 'dashboard', icon: LayoutDashboard },
  tasks: { module: 'tasks', icon: CheckSquare },
  projects: { module: 'projects', icon: FolderKanban },
  memos: { module: 'memos', icon: Pin },
  tips: { module: 'projects', icon: Lightbulb },
  ai: { module: 'ai', icon: Sparkles },
  templates: { module: 'templates', icon: LayoutTemplate },
  graph: { module: 'graph', icon: Waypoints },
  plugins: { module: 'plugins', icon: Puzzle },
  plugin: { module: 'plugins', icon: Puzzle },
  search: { module: 'neutral', icon: Search },
  tag: { module: 'neutral', icon: Hash },
  import: { module: 'neutral', icon: Upload },
  trash: { module: 'neutral', icon: Trash2 },
  settings: { module: 'neutral', icon: Settings },
  page: { module: 'neutral', icon: FileText },
};
